/**
 * @fileoverview MultipassPageContainer — vertical-stack wrapper used by every
 * Multipass-internal settings sub-page (Roles, Authentication, etc.). Provides
 * the standard 20px gap between header, callouts, and content cards.
 *
 * Foundry mapping: `multipass-internal__container`.
 */

import type { ReactNode } from "react";

interface MultipassPageContainerProps {
  children: ReactNode;
  className?: string;
}

export function MultipassPageContainer({ children, className }: MultipassPageContainerProps) {
  return (
    <div data-testid="multipass-page-container" className={["bp-mp-page-container", className].filter(Boolean).join(" ")}>
      {children}
    </div>
  );
}
